<template>
  <div id="goodsDrug" class="good__medicine goodsDrug" v-if="goodsList.length">
    <div class="good__medicine__header">
      <span class="good__medicine__header__title">{{ category.name }}</span>
      <el-button v-if="category.ref" @click="clickMore" plain class="good__medicine__header__more">
        查看更多
        <i class="el-icon-arrow-right"></i>
      </el-button>
    </div>
    <div class="good__medicine__content">
      <div class="good__medicine__content__tip">
        <div class="title">{{ category.title }}</div>
        <div class="sub__title">{{ category.subtitle }}</div>
        <div class="details">
          <img style="width: 100%; height: 100%" :src="category.pic" alt="" />
        </div>
      </div>
      <div class="medicine__list">
        <MedicineItem class="pointer" v-for="goods in goodsList" :key="goods.itemCode" :goods="goods" />
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
import MedicineItem from './MedicineItem';
export default {
  props: {
    category: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    MedicineItem
  },
  data() {
    return {
      goodsList: []
    };
  },
  methods: {
    async getGoodsList() {
      let { goodsSource, goods, categoryId } = this.category;
      let params = {
        pageNo: 1,
        pageSize: 4
      };
      if (goodsSource == 'manual') {
        params.skuIds = goods.join();
      } else if (goodsSource == 'category') {
        params.categoryCode = categoryId;
      }
      const res = await api.goods.getCategoryGoodsList(params);
      this.goodsList = res.list || [];
    },
    clickMore() {
      window.open(this.category.ref);
    }
  },
  created() {
    this.getGoodsList();
  }
};
</script>

<style lang="scss" scoped>
.good__medicine {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 32px;
    margin-bottom: 16px;
    &__title {
      font-size: 24px;
      font-weight: 500;
      color: #000000;
      line-height: 1;
    }
    &__more {
      padding-right: 0;
      font-size: 14px;
      font-weight: 400;
      color: #595959;
      line-height: 1;
      border: none;
    }
  }
  &__content {
    display: flex;
    width: 1232px;
    height: 366px;
    background: #0091ff;
    &__tip {
      width: 192px;
      text-align: center;
      padding: 0 12px;
      overflow: hidden;
      .title {
        margin-top: 30px;
        margin-bottom: 12px;
        font-size: 20px;
        font-weight: 500;
        color: #ffffff;
        line-height: 1;
      }
      .sub__title {
        margin-bottom: 8px;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 1;
      }
      .details {
        width: 168px;
        height: 266px;
        background: #d6f3e1;
      }
    }
    .medicine__list {
      flex: 1;
      overflow: hidden;
      display: flex;
      margin-top: 6px;
      background: #ffffff;
    }
  }
}
</style>
